
import * as React from "react";
import { createGuid } from "../../../../utils/CommonUtils";

import CarCard from "../CarCard/CarCard";
import classes from "./CarsCard.module.css";

const CarsCard = (props) => {
  return (
    <div className={classes.carCardContainer} component="fieldset">
      <div className={classes.carCardControl} variant="standard">
        {props?.carsTokens?.map((carsToken) => <CarCard key={createGuid()} isViewMode={props.isViewMode} parentSite={props.parentSite} {...carsToken}/> )}
        {props?.unassignedUserTokensSite?.map((un) => <CarCard key={createGuid()} isViewMode={props.isViewMode} parentSite={props.parentSite} {...un}/> )}
      </div>
    </div>
  );
};

export default CarsCard;
